module.exports = __webpack_public_path__ + "media/images/icons/material/open-envelope-741d879d4248486e6da4321716471736.svg";